import EventEmitter from 'eventemitter3';

import type { LogoutListenerCallbackType } from './types';

export enum ApiEventsNamesEnum {
  Logout = 'logout',
}

export const ApiEvents = {
  eventEmitter: new EventEmitter(),

  emit(eventName: string, ...args: any[]) {
    this.eventEmitter.emit(eventName, ...args);
  },

  addLogoutListener(cb: LogoutListenerCallbackType) {
    this.eventEmitter.addListener(ApiEventsNamesEnum.Logout, cb);
  },
};
